"use client";

import { useRef } from "react";
import { toast } from "sonner";
import { useAppEvent } from "@/lib/events";
import { useTranslation } from "react-i18next";

/**
 * Listens for the "context-trimmed" app event (dispatched by the SSE adapter
 * when the backend trims conversation context) and shows a toast notification.
 * Debounces to avoid spamming toasts on rapid successive trims.
 */
export function ContextTrimmedToastListener() {
  const { t } = useTranslation();
  const lastToastRef = useRef(0);

  useAppEvent("context-trimmed", () => {
    const now = Date.now();
    if (now - lastToastRef.current < 30_000) return;
    lastToastRef.current = now;

    toast.warning(t("thread.contextTrimmedTitle"), {
      description: t("thread.contextTrimmedDescription"),
      duration: 8000,
    });
  });

  return null;
}
